import SystemUtils from '../../../../../common/utils/system';


export default class RecError{

    constructor(){
        this._init();
    }


    render(index){
        //if(SystemUtils.isCT()) return;
        this.$self.setAttribute('data-error', index);
        this.$self.classList.add('-active');
    }


    hide(){
        this.$self.classList.remove('-active');
        this.$self.setAttribute('data-error', '');
    }

    _init(){
        this.$self = document.querySelector('.js-error');
        
        document.querySelector('.js-error__close').addEventListener('click',()=>{
            this.hide();
            GAME_REF.scene.nextScene();
        });
    }
}